import { createRoot } from 'react-dom/client';
import { AnalyticsProvider } from 'use-analytics';

import PackWrapper from 'components/common/PackWrapper';
import GlobalBannerContainer from 'components/globalBanners/GlobalBannerContainer';
import pixelAnalytics from 'helpers/analytics/pixelAnalytics';
import { getStore } from 'store/configure';

const store = getStore();

document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.querySelector('#hc-global-banners-react-app');
  const root = createRoot(rootElement);

  root.render(
    <PackWrapper rootElement={rootElement} store={store}>
      <AnalyticsProvider
        instance={pixelAnalytics({
          canTrack: rootElement?.getAttribute('data-can-track') === 'true',
        })}
      >
        <GlobalBannerContainer />
      </AnalyticsProvider>
    </PackWrapper>
  );
});
